import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '../Icon';
import { toggleSideMenuModal } from '../../actions';
import { selectSideMenuModalState } from '../../store/selectors';
import TabBarItemAuth from './TabBarItemAuth';

const TabBarItem = ({ item }) => {
  const {
    routes,
    path,
    name,
    icon,
    text,
    isSideMenuTab,
    isLink,
    isDefaultLink,
    iconW,
    iconH,
    isProfileTab
  } = item;
  const dispatch = useDispatch();
  const router = useRouter();
  const { pathname } = router;
  const currentPath = router.asPath.split('#')[0];
  const { isVisible: isVisibleSideMenuModal } = useSelector(
    selectSideMenuModalState
  );
  const getActiveTab = () => {
    if (isVisibleSideMenuModal) return isSideMenuTab;
    return routes.includes(pathname);
  };

  const openSideMenuModalHandler = () => {
    dispatch(toggleSideMenuModal(true));

    router.push(`${currentPath}#more`, undefined, {
      shallow: true
    });
  };
  const closeSideMenuModalHandler = () => {
    dispatch(toggleSideMenuModal(false));
  };
  const onProfileItemClickHandler = () => {
    closeSideMenuModalHandler();

    router.push(`${currentPath}#authentication`, undefined, {
      shallow: true
    });
  };
  const onClickDivContainerHandler = isSideMenuTab
    ? openSideMenuModalHandler
    : onProfileItemClickHandler;

  const tabBarItemContent = (
    <>
      <i className={'tab-bar__icon'}>
        <Icon
          indent={false}
          width={iconW}
          height={iconH}
          color={getActiveTab() ? 'dark' : 'brown'}
          IconComponent={icon}
        />
      </i>
      <span
        className={cn('tab-bar__link-text', {
          'tab-bar__link-text-active': getActiveTab()
        })}
      >
        {text}
      </span>
    </>
  );

  return (
    <li className="tab-bar__list-item">
      {(() => {
        switch (true) {
          case isProfileTab:
            return (
              <TabBarItemAuth path={path} onClick={onClickDivContainerHandler}>
                {tabBarItemContent}
              </TabBarItemAuth>
            );
          case isDefaultLink:
            return (
              <a
                className="tab-bar__link tab-bar__link--centered"
                href="/items/new"
                data-cy={`new-item-bar-link`}
                data-stat="new-item-bar-link"
              >
                {tabBarItemContent}
              </a>
            );
          case isLink:
            return (
              <Link
                href={path}
                onClick={closeSideMenuModalHandler}
                className={'tab-bar__link'}
                data-cy={`${name}-bar-link`}
                data-stat={`${name}-bar-link`}
              >
                {tabBarItemContent}
              </Link>
            );
          default:
            return (
              <div
                role="button"
                onKeyPress={onClickDivContainerHandler}
                onClick={onClickDivContainerHandler}
                className={'tab-bar__link'}
                tabIndex={0}
                data-cy={`${name}-bar-button`}
                data-stat={`${name}-bar-button`}
              >
                {tabBarItemContent}
              </div>
            );
        }
      })()}
    </li>
  );
};

TabBarItem.propTypes = {
  item: PropTypes.object
};

export default TabBarItem;
